export default [
  {
    'title': 'Customers',
    'icon': '',
    'href': process.env.VUE_APP_ROOT_API + '/admin/api/customer'
  },
  {
    'title': 'On Site Contacts',
    'icon': '',
    'href': process.env.VUE_APP_ROOT_API + '/admin/api/on_site_contact'
  },
  {
    'title': 'Trucks',
    'icon': '',
    'href': process.env.VUE_APP_ROOT_API + '/admin/api/code_truck'
  },
  {
    'title': 'Products',
    'icon': '',
    'href': process.env.VUE_APP_ROOT_API + '/admin/api/code_product'
  },
  {
    'title': 'File Types',
    'icon': '',
    'href': process.env.VUE_APP_ROOT_API + '/admin/api/code_file_type'
  },
  {
    'title': 'Areas',
    'icon': '',
    'href': process.env.VUE_APP_ROOT_API + '/admin/api/code_area'
  },
  {
    'title': 'Job Task Types',
    'icon': '',
    'href': process.env.VUE_APP_ROOT_API + '/admin/api/code_job_task_type'
  },
  {
    'title': 'Time Of Day',
    'icon': '',
    'href': process.env.VUE_APP_ROOT_API + '/admin/api/code_time_of_day'
  },
]
